import script from "./iconAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./iconAnimation.vue?vue&type=script&setup=true&lang=js"

import "./iconAnimation.vue?vue&type=style&index=0&id=58e3706a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e3706a"]])

export default __exports__